/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Card,
  CardTitle,
  Alert,
  Typography,
  Link
} from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import classNames from 'classnames';
import { defaultCardContentProps } from '../../constants/responsiveClassNames';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const QuotesError = React.forwardRef((props, ref) => {
  const {
    refreshQuotes
  } = useQuoteContext();
  return (
    <Card
      data-component="QuotesError"
      data-testid="quotes-container-error"
      className="sui-@container sui-h-full"
      ref={ref}
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
    >
      <CardTitle
        header={(
          <div className="sui-flex sui-gap-3 sui-items-center">
            <Orders /><Typography variant="h4" weight="display">Quotes</Typography>
          </div>
        )}
      />
      <Alert status="error" size="large">
        <div>
          <Typography variant="body-base" weight="bold">Something went wrong during loading</Typography>
          <Typography variant="body-base">
            <Link onClick={async (event) => {
              event.preventDefault();
              try {
                await refreshQuotes();
              } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error refreshing quotes:', err);
              }
            }}
            >
              Refresh Quotes
            </Link> to try again.
          </Typography>
        </div>
      </Alert>
    </Card>
  );
});

QuotesError.displayName = 'QuotesError';

export default QuotesError;
